const DRIVER_STORAGE_KEY = 'diesel_driver_names';

export function loadStoredDrivers() {
    try {
        const raw = JSON.parse(window.localStorage.getItem(DRIVER_STORAGE_KEY) || '[]');
        return Array.isArray(raw) ? raw.filter((n) => String(n || '').trim()) : [];
    } catch {
        return [];
    }
}

export function persistDriverName(name) {
    const trimmed = String(name || '').trim();
    if (!trimmed) return;
    const existing = loadStoredDrivers();
    if (existing.some((n) => n.toLowerCase() === trimmed.toLowerCase())) return;
    window.localStorage.setItem(DRIVER_STORAGE_KEY, JSON.stringify([...existing, trimmed]));
}

export function toDriverOptions(names) {
    const seen = new Set();
    return (names || [])
        .map((n) => String(n || '').trim())
        .filter((n) => {
            const key = n.toLowerCase();
            if (!n || seen.has(key)) return false;
            seen.add(key);
            return true;
        })
        .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
        .map((n) => ({ value: n, label: n }));
}
